import type * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from 'shared/src/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 [&>svg]:size-3',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-enhancetitle text-background shadow hover:bg-primary/80',
        secondary: 'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive: 'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        outline: 'border-border text-foreground bg-background',
      },
      status: {
        success: 'border-transparent ring-green-700 bg-green-200 text-green-700 shadow-none hover:bg-green-300',
        warning: 'border-transparent ring-yellow-700 bg-yellow-200 text-yellow-700 shadow-none hover:bg-yellow-300',
        new: 'border-transparent ring-sky-700 bg-sky-200 text-sky-700 shadow-none hover:bg-sky-300',
        error: 'border-transparent ring-red-700 bg-red-200 text-red-700 shadow-none hover:bg-red-300',
        pending: 'border-transparent ring-purple-700 bg-purple-200 text-purple-700 shadow-none hover:bg-purple-300',
        info: 'border-transparent ring-blue-700 bg-blue-200 text-blue-700 shadow-none hover:bg-blue-300',
        danger: 'border-transparent ring-red-700 bg-red-200 text-red-700 shadow-none hover:bg-red-300',
        blank: 'border-transparent ring-background bg-muted  text-muted-foreground shadow-none hover:bg-muted-foreground/40',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, status, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant, status }), className)} {...props} />;
}

export { Badge, badgeVariants };
